import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Menu } from '../../../menu/menu.model';
import { SessionService } from '@app/core/session/session.service';

@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.css']
})
export class BurgerMenuComponent implements OnInit {

  fControl = new FormControl();
  menuOpened: boolean;
  @Input() menu: Array<Menu>;
  jwt: string;
  isShowiServices: boolean = false;

  constructor(
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    this.menuOpened = false;
    this.jwt = this.sessionService.retrieveToken();
  }

  openMenu(): void {
    this.menuOpened = true;
  }

  onCloseMenu(closeEvent: boolean): void {
    this.menuOpened = !closeEvent;
  }

  onSubmit(submitted: boolean): void {
    if (submitted) {
      this.onCloseMenu(submitted);
    }
  }

}
